import { Expose, plainToInstance, Type } from "class-transformer";
import {
  IsDate,
  IsNotEmpty,
  IsOptional,
  IsString,
  ValidateNested,
} from "class-validator";
import { OnboardingStep } from "../onboarding-step";
import { AccountManager } from "../account-manager";
import { DesignProjectOnboardingBudget } from "../onboarding-step/design-project-onboarding-budget.entity";

export class DesignProject {
  public static from(designProject: DesignProject) {
    return plainToInstance(DesignProject, designProject, {
      excludeExtraneousValues: true,
    });
  }

  @Expose()
  @IsString()
  @IsNotEmpty()
  id!: string;

  @Expose()
  @IsString()
  @IsNotEmpty()
  accountId!: string;

  @Expose()
  @IsOptional()
  designProjectOnboardingStep?: OnboardingStep[];

  @Expose()
  @IsOptional()
  @ValidateNested()
  @Type(() => AccountManager)
  accountManager?: AccountManager | null;

  @Expose()
  @IsOptional()
  @ValidateNested()
  @Type(() => DesignProjectOnboardingBudget)
  designProjectOnboardingBudget?: DesignProjectOnboardingBudget | null;

  @Expose()
  @IsDate()
  createdTs!: Date;

  @Expose()
  @IsDate()
  updatedTs!: Date;
}
